<template>
  <a class="donate-cta gg-branding-lead-bg font-weight-bold" :href="donateUrl" target="_blank">{{ donateBtnText }}</a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DonateCta',
  computed: {
    ...mapGetters(['custom']),
    donateBtnText () { return this.custom('donate_text') },
    donateUrl () { return `${this.$store.state.dog.url}/donate` },
  }
}
</script>

<style scoped>
.donate-cta {
  padding: .75em 1.5em;
  border-radius: 5px;
  text-transform: uppercase;
  font-size: 1.25rem;
  color: white;
}
@media screen and (max-width: 767px) {
  a.donate-cta {
    margin-bottom: -1.5rem;
  }
}
</style>
